// PortalManagedRoute.js
// spec 000019 (revised): charging-strategy and group management is available in the mobile app for
// ALL operator-type users (private operators via the isOPU flag, plus Administrator / Company /
// Operation_Manager / Public_OPU). No user type is redirected away from these routes, so this list
// is empty and the guard is a pass-through. Kept wired in Routes.js so the policy has a single home
// if a subset ever needs to be portal-managed again.

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userTypeEnum } from '../../enums/auth/userType.enum';

export const PORTAL_MANAGED_USER_TYPES = [];

// Operator user types that keep charging-strategy and group management inside the mobile app.
export const OPERATOR_USER_TYPES = [
    userTypeEnum.OPU,
    userTypeEnum.Public_OPU,
    userTypeEnum.OperationManager,
];

export const isOperatorUserType = (userType) => OPERATOR_USER_TYPES.includes((userType || '').trim());

export const isPortalManagedUserType = (userType) => PORTAL_MANAGED_USER_TYPES.includes((userType || '').trim());

const PortalManagedRoute = ({ redirectTo = '/payments', children }) => {
    const { userInfo } = useSelector((state) => state.userInfoReducer);

    if (isPortalManagedUserType(userInfo?.userType)) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};

export default PortalManagedRoute;
